













import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { ISBMeasurementGuide } from '@shared/types/storyblok';

interface Props {
  measurement_guide?: ISBMeasurementGuide;
}

export default defineComponent({
  name: 'SizeGuideMeasurementGuide',
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    measurement_guide: {
      type: Object as PropType<ISBMeasurementGuide>,
      default: () => null,
    },
  },
  setup({ measurement_guide }: Props) {
    const title = computed(() => measurement_guide?.title);
    const description = computed(() => measurement_guide?.description);
    const imageFilename = computed(() => measurement_guide?.image?.filename);
    return {
      title,
      description,
      imageFilename,
    };
  },
});
